export default {
  title: 'Modules',

  slugName: {
    users: 'Users ',
    products: 'Products ',
    services: 'Services ',
    sales: 'Sales',
    purchases: 'Purchases',
    warehouses: 'Warehouses',
    treasury: 'Treasury',
    accountancy: 'Accountancy',
    connector: 'Woocontroller',
    events: 'Events',
    organizational_tickets: 'Internal Tickets',
    support_tickets: 'Support Tickets',
    financial_years: 'Financial Years',
    reports: 'Reports',
    backups: 'Backups',
    roles: 'Roles',
    settings: 'Settings'
  },

  labels: {
    slug: 'Slug',
    name: 'Name',
    price: 'Monthly price',
    salePrice: 'Sale price',
    status: 'Status',
    product: 'Product',
    description: 'Description',
    delete: 'Delete'
  },

  table: {
    header: {
      row: 'Row',
      name: 'Name',
      price: 'Monthly price',
      salePrice: 'Sale price',
      status: 'Status',
    }
  },

  statusTypes: {
    active: 'Active',
    disable: 'Disable'
  },

  notifications: {
    wrongInputValue: 'Input value is wrong',
    requiredModulesNotSelected: 'For enable this module, {modules} required',
    edit: {
      success: 'Module successfully updated',
      error: 'Update Module has error'
    },
    parseError: {
      name: 'Name is not valid',
      code: 'Code is not valid or is used to another Module',
      price: 'Price is not valid'
    }
  },

  list: {
    title: 'Modules'
  },

  insert: {
    title: 'Create Module'
  },

  edit: {
    title: 'Edit Module',
    dynamicTitle: 'Edit {name} Module'
  },

  profile: {
    title: 'Module profile',
    dynamicTitle: '{name} Module profile',

    importantData: {
      product: 'Product',
      status: 'Status'
    },

    actions: {
      logs: 'Activity logs'
    }
  },

  logs: {
    title: 'Module Logs'
  }
}
